import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { unblockAccount } from './server';
import { useLocation } from 'react-router-dom';
import { useTranslations } from 'js/hooks/i18n';
import { useRemoveQueryParams } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useUnblockAccount = () => {
    const t = useTranslations();
    const location = useLocation();
    const dispatch = useDispatch();
    const removeQueryParams = useRemoveQueryParams();
    const casinoName = useAppSelector(prop('casinoName'));

    useEffect(() => {
        const token = new URLSearchParams(location.search).get('2faToken');

        if (!token || !casinoName) {
            return;
        }

        (async () => {
            try {
                await unblockAccount({ casinoName, token });

                dispatch(showCommonPopupAction({
                    title: 'playtech.mobile.system.accountUnblock.success.title',
                    content: 'playtech.mobile.system.accountUnblock.success.content'
                }));
            } catch (error) {
                const defaultMessage = error?.response?.data?.errorMessage || 'playtech.mobile.system.error.default';

                dispatch(showCommonPopupAction({
                    content: t(`playtech.mobile.system.accountUnblock.error.${error?.response?.data?.errorCode}`, defaultMessage)
                }));
            }
        })();

        removeQueryParams(['2faToken']);
    }, [t, casinoName, dispatch, location.search, removeQueryParams]);
};
